import { useMutation, useQueryClient } from '@tanstack/react-query';
import { productsService } from '../services/products.service';

interface DeleteProductParams {
  id: string;
  reason?: string;
}

export function useDeleteProduct() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, reason }: DeleteProductParams) =>
      productsService.deleteProduct(id, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
  });
}
